<script setup>

import axios from 'axios'
import cookieHelper from '../cookie'
import {Field, Form, ErrorMessage} from 'vee-validate'
import {useFormSubmit} from "../../composables/useFormSubmit";
import {reactive, ref} from 'vue'
import useGlobalStore from '../../store/globalStore'

const schema = {
  roomType: 'required',
};

const { hideModal } = useFormSubmit()
const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)

const globalStore = useGlobalStore()

const onSubmit = async () => {
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  isSubmitting.value = true
  const form  = document.getElementById('enquirySuccessForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/enquiry-ch-success-submitted', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      const successData = JSON.stringify(
        {
          roomType: formData.get('roomType'),
        },
      );
      cookieHelper.setCookie('careHomeSuccessInfo', successData, 365);
      setTimeout(function () {
        hideModal();
      }, 4000);
    })
  })
}
</script>
<template>
  <Form
    class="modal-form modal-form--2column"
    id="enquirySuccessForm"
    @submit="onSubmit"
    :validation-schema="schema"
  >
    <slot name="token"></slot>
    <p class="fs-16 font-weight-bold color-pickled mt-1">
      What type of room are you looking for?
    </p>
    <div class="form-group form-group--input">
      <div class="radio-custom">
        <Field type="radio" id="standard_room" name="roomType" value="1" />
        <label class="form-check-label fs-16 font-weight-light-bold" for="standard_room">
          Standard room
          <i class="icon icon--help-room" v-tooltip.top-center="{content: 'These are usually single rooms. They are comfortable, private, and safe, and often have space for a television and a small item of personal furniture, such as an armchair. The residential care subsidy is available for standard rooms.', trigger: 'hover'}"></i>
        </label>
      </div>
      <div class="radio-custom">
        <Field type="radio" id="premium_room" name="roomType" value="2" />
        <label class="form-check-label fs-16 font-weight-light-bold" for="premium_room">
          Premium room
          <i class="icon icon--help-room" v-tooltip.top-center="{content: 'These are usually larger than a standard room with premium features such as an ensuite, private bathroom, or garden views. As with standard rooms, they are comfortable, private, and safe. Please note, additional fees apply.', trigger: 'hover'}"></i>
        </label>
      </div>
      <div class="radio-custom">
        <Field type="radio" id="care_suite" name="roomType" value="3" />
        <label class="form-check-label fs-16 font-weight-light-bold" for="care_suite">
          Care suite (sold on ORA)
          <i class="icon icon--help-room" v-tooltip.top-center="'These are usually spacious, studio-like suites, and often include a kitchenette, full ensuite bathroom, and private outdoor area. Most care suites are sold on an Occupation Right Agreement.'"></i>
        </label>
      </div>
      <ErrorMessage name="roomType" class="is-danger" />
    </div>

    <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>

    <input type="hidden" name="enquiry_id" id="enquiry_id_room_type" :value="globalStore.modal.id">
    <input type="hidden" name="enquiry_type_room" id="enquiry_type_room" value="enquiry-success-room">
    <button tabindex="12" type="submit" class="btn btn--green submit mt-4 fs-14 font-weight-bold pt-2 pb-2 w-100">
      Submit
    </button>
    <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
